export const LOCATIONS_LOAD = '@locations/load';
export const LOCATIONS_SELECT = '@locations/select';
export const LOCATIONS_EXIT = '@locations/exit';
